import { FC } from 'react';
import { RaptorTheme } from '../../../../styling/theme';
import { CustomColumn } from '../../../../types/components/tables/tableTypes';
import { AgTableData } from './AggregateExposureTable';
import CustomTable from '../../../tables/CustomTable';
import GeneralCard from '../../../general/GeneralCard';
import { useTheme } from '@mui/material';

export interface AssetGrossExposureProps {
  data: FundExposureData;
  fundId: string;
  fundName: string;
  isFetching: boolean;
}

export interface IVerticalData {
  data: any;
  value: any;
}

export const useAssetGrossExposureColumns =
  (): CustomColumn<IVerticalData>[] => {
    const generalStyle = {
      fontSize: '1.00rem',
    };
    const theme: RaptorTheme = useTheme();

    return [
      { title: 'DAta', field: 'data', cellStyle: { ...generalStyle } },
      {
        title: 'Field',
        field: 'value',
        cellStyle: {
          ...generalStyle,
          textAlign: 'right',
          // borderRight: theme.borders!.light,
        },
      },
    ];
  };

export function buildAssetGrossExposure(data: FundExposureData) {
  const { derivative, cash } = data.asset_type_gross_exposure;

  const items = [
    {
      data: 'Cash Securities',
      value: `${((cash / data.nav) * 100).toFixed(2)}%`,
    },
    {
      data: 'Derivative Securities',
      value: `${((derivative / data.nav) * 100).toFixed(2)}%`,
    },
  ];
  return items;
}

const AssetGrossExposure: FC<AssetGrossExposureProps> = ({
  data,
  fundId,
  fundName,
  isFetching,
}) => {
  const columns = useAssetGrossExposureColumns();
  const renderedData = buildAssetGrossExposure(data);

  return (
    <GeneralCard cardStyle={{ overflow: 'auto', marginBottom: '1.00rem' }}>
      <CustomTable<AgTableData>
        multipleTablePdfParameters={{
          specifiedWidth: 4,
          tablesInRow: 3,
          groupName: 'exposure_page',
          groupOrder: 2,
        }}
        id={`${fundId}_asset_class_gross_exposure`}
        title="Asset Gross Exposure"
        showToolbar={true}
        columns={columns}
        toolbarComponents={{
          toolbarTitle: 'Asset Gross Exposure',
        }}
        loading={isFetching}
        data={renderedData}
        options={{
          paging: false,
          search: false,
          header: false,
          exportButton: false,
        }}
        pdfDontMoveToNewPage
      />
    </GeneralCard>
  );
};

export default AssetGrossExposure;
